




import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const a = namespace("a");
@Component({
  components: {
    NodeContent: {
      props: {},
      render(h) {
        const parent = this.$parent;
        console.log(this, parent);
        return parent.renderContent(h, parent.updateData);
      }
    }
  }
})
export default class HelloWorld extends Vue {
  @Prop()
  updateData: any;
  @Prop()
  renderContent: any;
}
